import jQuery from 'jquery';

/**
 * Set global so you don't have to import it
 */
window.$ = window.jQuery = jQuery;
